var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassTitan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.114 15.979-13.178-7.609v15.218z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.886 15.979 13.178 7.609v-15.218z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.657 3.804-6.589-3.804-13.178 7.609 13.178 7.609 13.179-7.609z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22.657 20.588-6.589-3.805-13.178 7.609 13.178 7.608 13.179-7.608-6.59-3.805z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassTitan);
export default __webpack_public_path__ + "static/media/class-titan.c25e0a238d35f7131f6f80cace55bc77.svg";
export { ForwardRef as ReactComponent };